export function popupDisplay() {
  const banner = document.querySelector('.site-popup');
  const modal  = document.querySelector('.site-popup__modal');
  if (!banner || !modal) return;  

  banner.style.display = 'none';
  modal.style.display  = 'none';

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  }
  function getCookie(name) {
    return document.cookie.split('; ').reduce((r, v) => {
      const [k, val] = v.split('=');
      return k === name ? decodeURIComponent(val) : r;
    }, '');
  }

  function showPopup() {
    if (getCookie('sitePopupDismissed')) return;

    banner.style.display = 'flex';
    modal.style.display  = 'flex';
    requestAnimationFrame(() => {
      banner.classList.add('site-popup--visible');
      modal.classList.add('site-popup--visible');
    });

    let dismiss = modal.querySelector('.site-popup__button-close');
    if (!dismiss) {
      dismiss = document.createElement('button');
      dismiss.type        = 'button';
      dismiss.className   = 'site-popup__button-close wp-block-button__link is-style-outline';
      dismiss.textContent = 'Close';
    }

    const form   = modal.querySelector('form');
    const submit = form?.querySelector('button[type="submit"], input[type="submit"]');
    if (submit) {
      submit.insertAdjacentElement('afterend', dismiss);
    } else {
      modal.appendChild(dismiss);
    }

    dismiss.addEventListener('click', e => {
      e.preventDefault();
      setCookie('sitePopupDismissed', 'true', 7);
      closePopup();
    });

    banner.addEventListener('click', e => {
      if (e.target === banner) {
        setCookie('sitePopupDismissed', 'true', 7);
        closePopup();
      }
    });
  }

  function closePopup() {
    banner.classList.remove('site-popup--visible');
    modal.classList.remove('site-popup--visible');

    modal.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName === 'opacity') {
        modal.removeEventListener('transitionend', onEnd);
        banner.style.display = 'none';
        modal.style.display  = 'none';
      }
    });
  }

  function onScroll() {
    const scrollY   = window.pageYOffset || document.documentElement.scrollTop;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollY >= maxScroll / 2) {
      window.removeEventListener('scroll', onScroll);
      showPopup();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('scroll', onScroll);
    });
  } else {
    window.addEventListener('scroll', onScroll);
  }
}
